import makeStore from './storeFactory';

const {StoreProvider, useStore} = makeStore();

export {StoreProvider, useStore};
